//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
import { userTradeUrl, userTradeUrlCode } from "@/api";
import InteractivePanel from "@/components/interactive_panel";

export default {
  name: "SteamTradeUrlModal",

  components: {
    "c-interactive-panel": InteractivePanel,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialUrl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      visible: false,
      localUrl: "",
      loading: false,
      verification: {
        passCode: "",
        countdown: 90,
        countdownTimer: null,
        codeLoading: false,
      },
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(visible) {
        this.visible = visible;

        if (visible) {
          this.localUrl = this.initialUrl || "";
          this.verification.passCode = "";
        }
      },
    },
    initialUrl(url) {
      if (this.value) {
        this.localUrl = url || "";
      }
    },
  },

  beforeDestroy() {
    this.resetCountdown();
  },

  methods: {
    ...mapMutations(["setInfo"]),

    close() {
      if (!this.visible && !this.value) return;
      this.visible = false;
      this.$emit("input", false);
    },

    handleVisibleChange(visible) {
      if (!visible) {
        this.close();
      }
    },

    validateTradeUrl() {
      if (
        !/^https:\/\/steamcommunity\.com\/tradeoffer\/new\/?\?partner=\d+&token=.+$/.test(
          this.localUrl
        )
      ) {
        this.$toast.error("请填写正确的Url地址！");
        this.localUrl = "";
        return false;
      }

      return true;
    },

    countDown() {
      if (this.verification.countdownTimer) {
        clearInterval(this.verification.countdownTimer);
      }

      this.verification.countdown = 90;
      this.verification.countdownTimer = setInterval(() => {
        if (this.verification.countdown <= 1) {
          this.resetCountdown();
          return;
        }
        this.verification.countdown--;
      }, 1000);
    },

    resetCountdown() {
      if (this.verification.countdownTimer) {
        clearInterval(this.verification.countdownTimer);
      }
      this.verification.countdownTimer = null;
      this.verification.countdown = 90;
    },

    getTradeUrlCode() {
      if (this.verification.codeLoading || this.verification.countdownTimer) return;
      if (!this.validateTradeUrl()) return;

      this.verification.codeLoading = true;
      this.verification.passCode = "";

      userTradeUrlCode({
        tradeUrl: this.localUrl,
      })
        .then((res) => {
          if (res.data.code === 0) {
            this.$toast.success(res.data.msg);
            this.countDown();
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$toast.error("获取验证码失败，请稍后重试");
        })
        .then(() => {
          this.verification.codeLoading = false;
        });
    },

    setTradeUrl() {
      if (!this.validateTradeUrl()) return;
      if (!this.verification.passCode) return this.$toast.error("请输入验证码");

      this.loading = true;
      userTradeUrl({
        tradeUrl: this.localUrl,
        passCode: this.verification.passCode,
      })
        .then((res) => {
          if (res.data.code === 0) {
            this.setInfo();
            this.resetCountdown();
            this.$toast.success(res.data.msg);
            this.close();
          } else if (res.data.code == 1) {
            this.$toast.info(res.data.msg);
          } else {
            this.$toast.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$toast.error("绑定失败，请稍后重试");
        })
        .then(() => {
          this.verification.passCode = "";
          this.loading = false;
        });
    },
  },
};
